import { render, staticRenderFns } from "./batchSendOrders.vue?vue&type=template&id=b87a1228&scoped=true&"
import script from "./batchSendOrders.vue?vue&type=script&lang=js&"
export * from "./batchSendOrders.vue?vue&type=script&lang=js&"
import style0 from "./batchSendOrders.vue?vue&type=style&index=0&id=b87a1228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a1228",
  null
  
)

export default component.exports